
import React from "react";
// reactstrap components
import {
    Button,
    Card,
    CardImg,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Label,
    FormGroup,
    Form,
    Input,
    Row,
    Col, CardText
} from "reactstrap";

import avatar from "../../assets/img/TheDeepSharksLogo.jpg";
import bgImage from "../../assets/img/card-info.png";

const ContactUsForm = () => {
    return (
        <>
            <div className="content" style={{backgroundImage: "url("+require("../../assets/img/OutsideSandCourt2.jpg")+")", backgroundSize: "cover",
                backgroundPosition: "center center"}}>
                {/*<div className="main-content">*/}
                    <Row>
                        <Card className="card-user">
                            <CardBody>
                                <CardText />
                                <div className="author">
                                    <a href="http://www.thedeepvbc.com" onClick={(e) => window.location.href='http://www.thedeepvbc.com'}>
                                        <img
                                            alt="..."
                                            className="avatar"
                                            src={avatar}
                                        />
                                        <h3 className="title">Call or Email Us!</h3><br />
                                    </a>
                                    <p className="description"><span>
                                        Administrator<br />
                                        The Deep Sand Volleyball Club<br />
                                        Phone: (303) 324-9089<br />
                                        <br />
                                        <br />
                                        <Button href='http://www.thedeepvbc.com/contactus' className="btn-round btn-just-icon" color="info">
                                            Click Here to Email Us!
                                        </Button>
                                </span></p>
                                </div>
                            </CardBody>
                        </Card>
                        <Card

                            avatar={avatar}
                            name="Administrator"

                            description={
                                <span>
                                    Phone: (303) 324-9089
                                    <br />
                                    <br />
                                    <a href="mailto:rue@thedeepvbc.com?Subject=Contact me please!" target="_top">Click Here To Email Us</a>
                                </span>
                            }
                        />
                    </Row>
            </div>
        </>
    );
};

export default ContactUsForm;
